import { createContext } from 'react';
import { TextContextData } from './interfaces/text-context-props.interface';

const TextContext = createContext<TextContextData>({} as TextContextData);

export default TextContext;
